import React from "react";
import { object } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import FacebookIcon from "../../atoms/social-share-header-icons/facebook";
import InstagramIcon from "../../atoms/social-share-header-icons/instagram";
import TwitterShareIcon from "../../atoms/social-share-header-icons/twitter";
import YoutubeIcon from "../../atoms/social-share-header-icons/youtube";
import TelegramIcon from "../../atoms/social-share-header-icons/telegram";
import WhatsAppIcon from "../../atoms/social-share-header-icons/whatsapp";

import "./social-share.m.css";

const SocialShareIcons = ({ socialLinks, socials }) => {
  if (!socialLinks) {
    return null;
  }

  const WHATSAPP_URL = "https://www.whatsapp.com/channel/0029Va4ifN6AYlULZASc7V3S";
  const list = [
    {
      Type: <WhatsAppIcon isShareRequired={false} />,
      url: socials && socials.whatsapp ? socials.whatsapp.url : WHATSAPP_URL,
      name: "Whatsapp"
    },
    {
      Type: <FacebookIcon isShareRequired={false} />,
      url: socials && socials.facebook ? socials.facebook.url : socialLinks["facebook-url"],
      name: "Facebook"
    },
    {
      Type: <TwitterShareIcon isShareRequired={false} />,
      url: socials && socials.twitter ? socials.twitter.url : socialLinks["twitter-url"],
      name: "Twitter"
    },
    {
      Type: <InstagramIcon isShareRequired={false} />,
      url: socials && socials.instagram ? socials.instagram.url : socialLinks["instagram-url"],
      name: "Instagram"
    },
    {
      Type: <YoutubeIcon isShareRequired={false} />,
      url: socials && socials.youtube ? socials.youtube.url : socialLinks["youtube-url"],
      name: "Youtube"
    },

    {
      Type: <TelegramIcon isShareRequired={false} />,
      url: socials && socials.telegram ? socials.telegram.url : socialLinks["telegram-url"],
      name: "Telegram"
    }
  ];

  return (
    <div styleName="wrapper" className="social-icons-wrapper">
      {list.map(({ url, Type, name }, index) => (
        <a
          href={url}
          key={index}
          styleName="social-link-item"
          className="social-link-item"
          target="_blank"
          rel="nofollow noreferrer"
        >
          {Type}
        </a>
      ))}
    </div>
  );
};

SocialShareIcons.propTypes = {
  socialLinks: object,
  socials: object
};

const mapStateToProps = (state) => ({
  socialLinks: get(state, ["qt", "config", "social-links"], {})
});

export default connect(mapStateToProps, null)(SocialShareIcons);
